module.exports = __webpack_public_path__ + "img/big.7e84fd91.jpg";